import styled from 'styled-components';

export const StyledLightningLinkMainProduct = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 32px;
  border-radius: 4px;
  position: relative;
  display: flex;
  align-items: center;
  z-index: 1;

  .product-img {
    height: 64px;
    width: 64px;
    position: absolute;
    z-index: -1;
    left: 50%;
    transform: translateX(-50%);
    bottom: 18px;

    .image {
      position: absolute;
      height: 64px;
      width: auto;
    }
  }

  .content-container {
    width: 100%;
    height: 32px;
    background: rgba(49, 21, 132, 0.9);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;
    font-size: 12px;
    font-family: ${(props: any) => props.fontFamily};
    min-width: 0;

    .stroked-container,
    .quantity-container {
      padding: 0 4px;
      min-width: 0;
      z-index: 1;
      width: 100%;
      text-align: center;
      justify-content: center;
    }

    .quantity-container {
      &__value {
        display: flex !important;
        justify-content: center;
        align-items: center;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        color: #fff;
        width: calc(100% + 20px);
        text-transform: uppercase;
      }
    }

    .stroked-container {
      &__value {
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: #fff;
        width: 100%;
        text-decoration: line-through;
        text-decoration-color: #f00;
      }
    }

    .tooltip-icon {
      height: 16px;
    }
  }
` as any;

export const StyledLightningLinkSubProduct = styled.div<{
  isTooltipShown: boolean;
}>`
  box-sizing: border-box;
  width: 100%;
  height: 32px;
  background: #311584;
  border-radius: 4px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;

  .product-info {
    display: flex;
    align-items: center;
    padding-left: 4px;
    width: 100%;

    .product-img {
      min-width: 32px;
      max-height: 32px;
      display: flex;
      justify-content: center;
      position: relative;

      .image {
        height: 32px;
        width: 32px;
      }
    }

    .price-container {
      padding-left: 4px;
      padding-right: ${(props: any) => (props.isTooltipShown ? '22px' : '4px')};
      min-width: 0;
      width: 100%;

      .quantity-container {
        &__value {
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          color: #fff;
          width: 100%;
          text-transform: uppercase;
        }
      }
    }
  }

  .tooltip-icon {
    height: 16px;
  }
` as any;
